import Dexie, {Table} from "dexie";
export interface DeviceUniqueId {
	id?: number;
	deviceUniqueIdentifier?: string;
}
export interface UssdChannelData {
	id?: number;
	canShowModal: boolean;
	userId?:number;
	timestamp?: number;
  }
export class IndexDb extends Dexie{
	deviceUniqueId!: Table<DeviceUniqueId, number>;
	ussdBankingChannel!: Table<UssdChannelData, number>;

	constructor() {
		super('moniepoint-frontoffice');
		this.version(4).stores({
			deviceUniqueId: '++id',
			ussdBankingChannel: '++id, userId, timestamp',
		});
		this.on('populate', () => this.populate());
	}

	async populate() {
		await indexDb.deviceUniqueId.add({
			deviceUniqueIdentifier: '',
			id: 1
		});
	}
}
export const indexDb = new IndexDb();
